// MoreDropDown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from '../Navbar.module.css';

export default function MoreDropDown() {
    const [dropDown, setDropDown] = useState(false);
    const dropdownRef = useRef(null);
    const navigateTo = useNavigate();

    useEffect(() => {
        function handleClickOutside(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropDown(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <>
            <div className={Classes.dropDown} ref={dropdownRef}>
                <button className={Classes.primaryBtn} onClick={() => setDropDown(!dropDown)}> Sign up </button>

                <AnimatePresence>
                    {dropDown && (
                        <motion.div
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -5 }}
                            transition={{ duration: 0.15 }}
                            className={Classes.dropDownBody}
                        >
                            <div className={Classes.dropDownBodyInner}>
                                <div
                                    className={Classes.dropDownElem}
                                    style={{ padding: '5px 10px' }}
                                    onClick={() => {
                                        navigateTo('/signup/customer')
                                        setDropDown(false);
                                    }}
                                >
                                    <h5>Customer</h5>
                                </div>
                                <div className={Classes.dropDownLine}></div>
                                <div
                                    className={Classes.dropDownElem}
                                    style={{ padding: '5px 10px' }}
                                    onClick={() => {
                                        navigateTo('/signup/manufacturer')
                                        setDropDown(false);
                                    }}
                                >
                                    <h5>Manufacturer</h5>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
                <input type="hidden" aria-label="Without label" readOnly />
            </div>

        </>
    );
}
